import React, { useReducer } from "react";
import { HashRouter, Route, Switch,Redirect  } from "react-router-dom";
import { ProvideAuth } from "@/component/Auth";
import { ProviderPage } from "./component/PageControl";
import { RTMProvider } from "./component/Rtm/";

// main
import Login from "@/pages/main/Login";
import Register from "@/pages/main/Register";
import LosePass from "./pages/main/Losepass";
import JoinMeeting from "./pages/main/JoinMeeting";

import QuickMeeting from "./pages/main/QuickMeeting";
import AppointmentMeeting from "./pages/main/AppointmentMeeting";
import AppointNew from "./pages/main/AppointmentMeeting/New";
import HistoryMeeting from "./pages/main/HistoryMeeting";
import Contacts from "./pages/main/Contacts";
// settings

import Meeting from "./pages/Meeting";
import Demo from "./pages/Demo";

import NormalSetting from "@/pages/settings/NormalSetting";
import VideoSetting from "@/pages/settings/VideoSetting";
import AudioSetting from "@/pages/settings/AudioSetting";
import NetworkSetting from "@/pages/settings/NetworkSetting";
import MeetingSetting from "./pages/settings/MeetingSetting";
import EnvSetting from "./pages/settings/EnvSetting";

import SmallLayout from "@/layouts/SmallLayout";
import GlobalStyle from "@/css/index";

import ChromeCheck from "./component/ChromeCheck";

import MessageNotify from "./pages/main/Contacts/messagenotify";
import StateContext from "./MyStateContext"
import {Action,reducer, initialState} from "./Action"
import Manage from "./pages/main/Manage";
import Create from "./pages/main/Manage/create";
import Users from "./pages/main/Users";
import { useMqtt } from "@/hooks/use-mqtt";

(function() {
  const originalCreateElement = document.createElement;

  document.createElement = function(tagName:any) {
    const element = originalCreateElement.call(document, tagName);

    if (tagName.toLowerCase() === 'script') {
      const originalSetAttribute = element.setAttribute;
      element.setAttribute = function(name, value) {
        if (name === 'src' && value && value.includes('at.alicdn.com')) {
          console.log('阻止阿里图标加载:', value);
          return; // 不设置src，阻止加载
        }
        return originalSetAttribute.call(this, name, value);
      };
    }

    return element;
  };
})();

// 创建一个Provider组件
function MyProvider(props:any) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <StateContext.Provider value={value} {...props} />;
}
// @ts-ignore
const App = () => {
  const { connect } = useMqtt()
  connect()
  return (
    <MyProvider>
<RTMProvider>
    <ProvideAuth>
      <GlobalStyle />
      <ChromeCheck />
      <MessageNotify />
      <HashRouter>
        <Switch>
          <Route path="/demo">
            <Demo />
          </Route>
          {/* <Route path="/live">
              <LiveStreamApp />
            </Route> */}
          <ProviderPage>
            <Route exact path="/meeting/:id">
              <Meeting />
            </Route>

            <SmallLayout>
              <Route path="/login">
                <Login />
              </Route>
              <Route path="/register">
                <Register />
              </Route>
              <Route path="/losepass">
                <LosePass />
              </Route>
              <Route exact path="/">
                <JoinMeeting />
              </Route>
              <Route path="/main/quick">
                <QuickMeeting />
              </Route>
              <Route path="/main/appointment">
                <AppointmentMeeting />
              </Route>
              <Route path="/main/appointnew">
                <AppointNew />
              </Route>
                  
              <Route path="/main/users">
                <Users />
              </Route>
              <Route path="/main/manage">
                <Manage />
              </Route>
              <Route path="/main/manage-create">
                <Create />
              </Route>

              <Route path="/main/history">
                <HistoryMeeting />
              </Route>

              <Route path="/main/contacts">
                <Contacts />
              </Route>

              <Route path="/setting/normal">
                <NormalSetting />
              </Route>
              <Route path="/setting/video">
                <VideoSetting />
              </Route>
              <Route path="/setting/audio">
                <AudioSetting />
              </Route>
              <Route path="/setting/network">
                <NetworkSetting />
              </Route>
              <Route path="/setting/meeting">
                <MeetingSetting />
              </Route>
              <Route path="/setting/env">
                <EnvSetting />
              </Route>
              <footer>
                <a href="https://beian.miit.gov.cn/" target="_blank">
                  京ICP备20014981号-1
                </a>
              </footer>
            </SmallLayout>
            {/* <PrivateRoute exact path="/">
            <Entry />
          </PrivateRoute> */}
          </ProviderPage>
        </Switch>
      </HashRouter>
    </ProvideAuth>
    </RTMProvider>
    </MyProvider>
  );
};

export default App;
